<template>
  <!-- Legacy WebForms page: a full page load, the router knows nothing about it. -->
  <a v-if="isLegacyUrl"
    :href="legacyHref"
    @click="$showSpinner()">
    <slot />
  </a>
  <!-- No destination. Nav items from the API can carry a null url, and those
       render as plain text that happens to be styled like the others. -->
  <a v-else-if="!routePath">
    <slot />
  </a>
  <!-- Everything else. router-link renders a real <a href> with the router base
       applied (/v2/ on staging & production), so the browser gives us
       middle-click, ctrl-click, "open in new tab" and the hover status bar for
       free. Never hand-build these URLs: window.open() and :href need a browser
       URL, while $router.push() needs a base-less router path, and mixing the
       two up is how the /v2 prefix goes missing. -->
  <router-link v-else
    :to="routePath">
    <slot />
  </router-link>
</template>
<script>
export default {
  name: 'AppLink',
  props: {
    // Either a router path ('/company/onboarding') or a legacy WebForms url
    // containing '~', which is swapped for VUE_APP_ROOT_URI.
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLegacyUrl() {
      return !!this.url && this.url !== 'null' && this.url.indexOf('~') > -1
    },
    legacyHref() {
      return this.url.replace('~', process.env.VUE_APP_ROOT_URI)
    },
    routePath() {
      if (!this.url || this.url === 'null' || this.isLegacyUrl) {
        return ''
      }
      // Leading slash matters: the router resolves a relative path against the
      // current route instead of against the base.
      return this.url.charAt(0) === '/' ? this.url : `/${this.url}`
    }
  }
}
</script>
